module.exports = __webpack_public_path__ + "img/add_col_before.427aee09.svg";